import React from "react";

export default function CardContent({ children }) {
  return <div className="card-content">{children}</div>;
}
